import { render, staticRenderFns } from "./bom_compare.vue?vue&type=template&id=68da6c7c&scoped=true&"
import script from "./bom_compare.vue?vue&type=script&lang=js&"
export * from "./bom_compare.vue?vue&type=script&lang=js&"
import style0 from "./bom_compare.vue?vue&type=style&index=0&id=68da6c7c&scoped=true&lang=less&"
import style1 from "./bom_compare.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da6c7c",
  null
  
)

export default component.exports